import Vue from "vue";

export default {
	state: {
		blackListedSuppliers: []
	},
	mutations: {
		setBlackListedOnState(state, blackListedSuppliers) {
			state.blackListedSuppliers = mapListedSuppliers(blackListedSuppliers);
		}
	},
	actions: {
		getBlackListedSuppliers({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("blacklist")
					.then((response) => {
						commit("setBlackListedOnState", response.data.data);
						resolve(response);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		async removeBlackListedSupplier(_, cnpjCpf) {
			let formatedCnpjCpf = Vue.prototype.$functions.formatCnpjCpfToBack(cnpjCpf);
			this.state.loading = true;
			try {
				return await new Promise((resolve) => {
					Vue.prototype.$http.delete("blacklist/" + formatedCnpjCpf).then((response) => {
						this.state.loading = false;
						resolve(response);
					});
				});
			} catch (error) {
				console.error(error);
				this.state.loading = false;
			}
		},
		async createBlackListedSupplier(_, listedSupplier) {
			let formatedCnpjCpf = Vue.prototype.$functions.formatCnpjCpfToBack(listedSupplier.cnpjCpf);
			listedSupplier.cnpjCpf = formatedCnpjCpf;
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("blacklist", listedSupplier)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		getCheckBlackListed(_, dataObj) {
			dataObj.cnpjCpf = Vue.prototype.$functions.formatCnpjCpfToBack(dataObj.cnpjCpf);
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("blacklist/check/", dataObj).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		checkBlackListedHasInvite(_, cnpjCpf) {
			let formatedCnpjCpf = Vue.prototype.$functions.formatCnpjCpfToBack(cnpjCpf);
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("blacklist/inviteCheck/" + formatedCnpjCpf).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		}
	},
	getters: {
		blackListedSuppliers({ blackListedSuppliers }) {
			return blackListedSuppliers;
		}
	}
};

const mapListedSuppliers = (blackListedsFromBack) => {
	let response = [];
	blackListedsFromBack.forEach((blackListedSupplier) => {
		let cnpjCpfFormated = Vue.prototype.$functions.cnpjCpfFormatFromBack(blackListedSupplier.cnpjCpf);
		blackListedSupplier.cnpjCpf = cnpjCpfFormated;
		response.push(blackListedSupplier);
	});
	return response;
};
